import React from 'react';

import { Box, Typography } from '@material-ui/core';
import Checkbox from 'components/V2/Checkbox';
import PropTypes from 'prop-types';
import { SSN_CONFIGURATION_TYPES } from 'views/V2/Workflow/constants';

import styles from '../../userInformation.module.css';

const DoNotCollectSsnFallback = ({ onFallbackChange, isFallbackAlreadyAdded }) => {
    return (
        <Box className={styles.fallback_container}>
            <Box>
                <Typography className={styles.fallback_heading}>Fallback:</Typography>
                <Typography className={styles.fallback_sub_text}>
                    Enables the user to add partial SSN for identity verification when check fails
                    without SSN.
                </Typography>
            </Box>
            <Box className={styles.ssn_fallback_container}>
                <Box className={styles.fallback_ssn_options}>
                    <Typography className={styles.fallback_ssn_option_text}>
                        Success: <strong>Highest using Full SSN</strong>
                    </Typography>
                </Box>
                <Box className={styles.fallback_ssn_options}>
                    <Typography className={styles.fallback_ssn_option_text}>
                        Request Partial SSN
                    </Typography>
                    <Checkbox
                        checked={isFallbackAlreadyAdded(
                            SSN_CONFIGURATION_TYPES.COLLECT_PARTIAL_SSN
                        )}
                        onChange={() =>
                            onFallbackChange(SSN_CONFIGURATION_TYPES.COLLECT_PARTIAL_SSN)
                        }
                    />
                </Box>
                <Box className={styles.fallback_ssn_options}>
                    <Typography className={styles.fallback_ssn_option_text}>
                        Request Full SSN if Partial SSN is not sufficient
                    </Typography>
                    <Checkbox
                        checked={isFallbackAlreadyAdded(SSN_CONFIGURATION_TYPES.COLLECT_FULL_SSN)}
                        onChange={() => onFallbackChange(SSN_CONFIGURATION_TYPES.COLLECT_FULL_SSN)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

DoNotCollectSsnFallback.propTypes = {
    onFallbackChange: PropTypes.func,
    isFallbackAlreadyAdded: PropTypes.func,
};

export default DoNotCollectSsnFallback;
